import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as entityViewsActions from '@entity-views/store/actions/entitiy-views.actions';

@Injectable({ providedIn: 'root' })
export class EntityViewsStoreService {

    constructor(private readonly store: Store) { }

    public loadViewCounts(): void {
        this.store.dispatch(entityViewsActions.loadViewCounts());
    }
}